import { getComponents } from 'store/backendControlled/actions/getComponents'
import { BackendControlledSlice } from 'store/backendControlled/slice'

export const BackendControlledActions = {
  ...BackendControlledSlice.actions,
  getComponents,
}
